import { CMDNewBlackjackSeatInfo } from "./CMDNewBlackjackSeatInfo"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpNewBlackjackSeatInfo implements ICommand
{

	public HostID : number = 0;
	public GameID : number = 0;
	public SeatInfo : Array<CMDNewBlackjackSeatInfo>;

	public constructor()
	{
		this.SeatInfo = new Array<CMDNewBlackjackSeatInfo>();
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.GameID = ba.readUint53();
		let SeatInfoSize:number = ba.readUint8();
		while (SeatInfoSize-- > 0)
		{
			let SeatInfoChild:CMDNewBlackjackSeatInfo = new CMDNewBlackjackSeatInfo();
			SeatInfoChild.fromBytes(ba);
			this.SeatInfo.push(SeatInfoChild);
		}
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint53(this.GameID);
		ba.writeUint8(this.SeatInfo.length);
		for (const SeatInfoChild of this.SeatInfo)
		{
			let tempBuf = SeatInfoChild.toBytes();
			ba.appendBuf(tempBuf.toBuffer());
		}

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpNewBlackjackSeatInfo();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'SeatInfo_size(B)='+this.SeatInfo.length + ' ';
		str += 'SeatInfo(CMDNewBlackjackSeatInfo)=[';
		for (let SeatInfoChild in this.SeatInfo)
		{
			if (<number><unknown>SeatInfoChild > 0) str += ', ';
			str += this.SeatInfo[SeatInfoChild].toString();
		}
		str += '] ';
		return str;
	}

	public getCmdID() : number
	{
		return 50142;
	}

	public getCmdName() : string
	{
		return 'SpNewBlackjackSeatInfo';
	}

}
